import React from "react";
import { Link } from "react-router-dom";

const sizes = {
  sm: "px-3 py-1.5 text-sm",
  md: "px-4 py-2 text-base",
  lg: "px-5 py-2.5 text-lg",
};

const variants = {
  primary:
    "bg-blue-600 text-white hover:bg-blue-700 active:bg-blue-800 shadow-sm",
  secondary: "bg-gray-200 text-gray-900 hover:bg-gray-300 active:bg-gray-400",
  outline:
    "border border-gray-400 text-gray-700 hover:bg-gray-100 active:bg-gray-200",
  danger: "bg-red-600 text-white hover:bg-red-700 active:bg-red-800",
};

function CustomLink({
  to,
  children,
  size = "md",
  variant = "primary",
  className = "",
}) {
  return (
    <Link
      to={to}
      className={`
        inline-flex items-center justify-center rounded-lg font-medium 
        transition-all duration-200 
        ${sizes[size]} 
        ${variants[variant]} 
        ${className}
      `}
    >
      {children}
    </Link>
  );
}
export default React.memo(CustomLink);
